export { default } from './alternate-part-sections';
